import { render, staticRenderFns } from "./aggreement.vue?vue&type=template&id=10bcf935&scoped=true"
import script from "./aggreement.vue?vue&type=script&lang=js"
export * from "./aggreement.vue?vue&type=script&lang=js"
import style0 from "./aggreement.vue?vue&type=style&index=0&id=10bcf935&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bcf935",
  null
  
)

export default component.exports